import { IAnyModelType, Instance, types } from 'mobx-state-tree';
import { ComponentModel, TabsModel } from '../../../internal';

export const TabModel: IAnyModelType = types
  .compose(
    ComponentModel,
    types.model({
      parent: types.maybe(types.reference(types.late(() => TabsModel))),
    })
  )
  .actions((self) => {
    return {
      setParent(parent: string) {
        self.parent = parent;
      },
      remove() {
        if (!self.isDisabled) {
          self.parent.remove(self);
        }
      },
    };
  })
  .views((self) => {
    return {};
  })
  .named('TabModel');

export type TabModelType = Instance<typeof TabModel>;
